import React, { FC } from 'react';

import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
  WarningOutlined,
} from '@ant-design/icons';

import { AlertWrapper } from './styled';

export interface IAlert {
  type: 'success' | 'error' | 'info' | 'warning';
  title?: string;
  description: string;
  showIcon?: boolean;
  className?: string;
}

const AlertIcons = {
  success: CheckCircleOutlined,
  error: CloseCircleOutlined,
  info: InfoCircleOutlined,
  warning: WarningOutlined,
};

const Alert: FC<IAlert> = ({
  type = 'warning',
  title,
  description,
  showIcon = true,
  className,
}) => {
  const AlertIcon = AlertIcons[type];

  return (
    <AlertWrapper className={className} variant={type}>
      {showIcon && (
        <div>
          <AlertIcon className='alert__icon' />
        </div>
      )}
      <div className='alert__body'>
        {title && <h6>{title}</h6>}
        <p>{description}</p>
      </div>
    </AlertWrapper>
  );
};

export default Alert;
